
import Vue from 'vue';
import { mapGetters } from 'vuex';
export default Vue.extend({
  name: 'InformationsMarche',
  computed: {
    ...mapGetters({ informationsMarche: 'referentiel/informationsMarche' })
  }
});
